import Button from "./Button"
import cn from "classnames"
import icons from '../../markons/markons'
import Icon, {Spinner} from './Icon'
import type {ComposedFC} from '../helpers/react-helpers';
import { withClass, withDefaultProps} from '../helpers/react-helpers'
import ActionButton from './ActionButton'
import React from 'react'
import {BaseLink, LinkButton} from './external-links'
import ActionLink from './ActionLink'

export const SubmitButton = withDefaultProps(Button,{type:'submit'});

export default function SaveSubmitButton({className, ...props}: React.ComponentPropsWithoutRef<typeof Button>) {
    return <Button className={cn('btn-save', className)} type="submit" {...props} />
}

export function SaveIconSubmitButton({className, children = "Save", ...props}: React.ComponentPropsWithoutRef<typeof SaveSubmitButton>) {
    return <SaveSubmitButton className={className} {...props}><Icon name={icons.miscSave}/> {children}</SaveSubmitButton>
}

interface SaveButtonProps extends React.ComponentPropsWithoutRef<typeof ActionButton> {
    icon?: ValueOf<typeof icons>
    processing: boolean
}

export function SpinnerButton({className, children, icon=icons.miscSave, processing, disabled, ...props}: SaveButtonProps) {
    return (
        <ActionButton className={cn(className)} disabled={processing||disabled} {...props}>
            {processing ? <Spinner/> : <Icon name={icon}/>} {children}
        </ActionButton>
    )
}

export const SaveButton = withDefaultProps(SpinnerButton, {
    children: 'Save',
    icon: icons.miscSave,
    className: 'btn-save',
})

export const DeleteButton = withDefaultProps(SpinnerButton, {
    children: 'Delete',
    icon: icons.ionTrashA,
    className: 'btn-delete',
})

export function DeleteIconLink({className,...props}: React.ComponentPropsWithoutRef<typeof ActionLink>) {
    return <ActionLink {...props} className={cn('mrkn ion-trash-a delete-link mrkn-lrg',className)}/>
}

export const ButtonLink = withClass(BaseLink,'btn')

export function CancelLink({children = "Discard", ...props}: React.ComponentPropsWithoutRef<typeof ButtonLink>) {
    return <ButtonLink className="btn-default" {...props}><Icon name={icons.ionBackspaceOutline}/> {children}</ButtonLink>
}

export const CancelLinkRoute: ComposedFC<typeof LinkButton> = ({children,className,...props}) => (
    <LinkButton className={cn('btn-default',className)} {...props}><Icon name={icons.ionBackspaceOutline}/>{children}</LinkButton>
)


export const NewActionButton = withClass(ActionButton,'btn-new');

export const ActionButtonIcon: ComposedFC<typeof ActionButton,{icon:ValueOf<typeof icons>}> = ({icon,children,...props}) => (
    <ActionButton {...props}><Icon name={icon}/>{children}</ActionButton>
)

export const CancelButton = withDefaultProps(ActionButtonIcon,{icon:icons.ionBackspaceOutline})
